import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import {Button} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, RadioList, FileUpload, ImageUpload, Select, ToggleButton, Checkbox, Number, Mp4Upload} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import ButtonToolbar from '../../components/ButtonToolbar';
import IconCheckbox from "../../components/Form/IconCheckbox";
import QsectionLookup from "../../components/Form/QsectionLookup";

class OptionSubform extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			overRemove: false
		}
	}

	handleMouseOver() {
		this.setState({overRemove: true});
	}

	handleMouseOut() {
		this.setState({overRemove: false});
	}

	render() {
		return (
			<tr className={this.state.overRemove ? 'subformOverRemove' : null}>
				<td><FormField name="text" /></td>
				<td><FormField name="correct" /></td>
				<td><i title="Odstranit"
				       onClick={this.props.onRemove}
				       onMouseOver={() => this.handleMouseOver()}
				       onMouseOut={() => this.handleMouseOut()}
				       className="icon-cross removesubform"/>
				</td>
			</tr>
		)
	}
}

@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'question.fetch',
			save: 'question.save',
			remove: 'question.delete'
		};

		this.changeEvent = 'question.change';

		this.messages = {
			remove: 'Opravdu si přejete otázku odstranit?',
			notfound: 'Otázka nenalezena!'
		};

		this.schema = {
			published: {
				class: IconCheckbox,
				label: 'Aktivní',
				value: 1
			},
			qsection: {
				class: QsectionLookup,
				label: 'Oblast',
				rules: {
					presence: {message: 'Oblast je povinná položka!'}
				}
			},
			points: {
				class: Number,
				label: 'Bodů',
				value: 4,
				style: {width: 60}
			},
			image: {
				class: ImageUpload,
				label: 'Obrázek'
			},
			video: {
				class: Mp4Upload,
				label: 'Video (MP4)'
			},
			text: {
				class: TextInput,
				label: 'Popis',
				autoFocus: !props.id,
				rules: {
					presence: {message: 'Popis je povinná položka!'}
				}
			},

			op_a: {
				class: ToggleButton,
				title: 'A',
			},
			op_b: {
				class: ToggleButton,
				title: 'B',
			},
			op_c: {
				class: ToggleButton,
				title: 'C',
			},
			op_d: {
				class: ToggleButton,
				title: 'D',
			},
			op_e: {
				class: ToggleButton,
				title: 'E',
			},
			op_f: {
				class: ToggleButton,
				title: 'F',
			},
			op_g: {
				class: ToggleButton,
				title: 'G',
			},
			op_w1: {
				class: ToggleButton,
				title: 'W1',
			},
			op_w2: {
				class: ToggleButton,
				title: 'W2',
			},
			op_m: {
				class: ToggleButton,
				title: 'M',
			},
			op_z: {
				class: ToggleButton,
				title: 'Z',
			},

			op_a_2: {
				class: ToggleButton,
				title: 'A',
			},
			op_b_2: {
				class: ToggleButton,
				title: 'B',
			},
			op_c_2: {
				class: ToggleButton,
				title: 'C',
			},
			op_d_2: {
				class: ToggleButton,
				title: 'D',
			},
			op_e_2: {
				class: ToggleButton,
				title: 'E',
			},
			op_f_2: {
				class: ToggleButton,
				title: 'F',
			},
			op_g_2: {
				class: ToggleButton,
				title: 'G',
			},
			op_w1_2: {
				class: ToggleButton,
				title: 'W1',
			},
			op_w2_2: {
				class: ToggleButton,
				title: 'W2',
			},
			op_m_2: {
				class: ToggleButton,
				title: 'M',
			},
			op_z_2: {
				class: ToggleButton,
				title: 'Z',
			},

			options: {
				class: Multiform,
				label: 'Odpovědi',
				addLabel: 'přidat odpověd',
				value: [{id: -1, title: ''}],
				subform: OptionSubform,
				schema: {
					text: {
						class: TextInput,
						label: 'Text',
						style: {width: 700},
						rules: {
						 	presence: {message: 'Text je povinná položka!'}
						}
					},
					correct: {
						class: IconCheckbox,
						label: 'Správně'
					}
				}
			}
		};
		this.form = new FormManager(this.schema);
	}

	componentDidMount() {
		this.form.on('change', (key, value) => {
			if (key == 'text') {
				this.title = value;
			}
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.text});
	}

	render() {

		const loading = !!(this.props.form && this.props.form.get('saving'));
		const canEdit = true || this.user.isAllowed('user', 'update');
		const canDelete = true || this.user.isAllowed('user', 'delete');
		const isNew = !this.props.id;

		const saveCloseButton = <LoadingButton
			disabled={!canEdit}
			title="Uložit"
			loading={loading}
			onClick={()=>this.save(true)}
		/>;

		const toolbar = [
			{
				title: 'Uložit',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'primary',
				onClick: () => this.save(true)
			},
			{
				title: 'Uložit a pokračovat v editaci',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'default',
				onClick: () => this.save()
			},
			{
				title: 'Uložit a nový',
				icon: 'fa fa-file-o',
				loading: loading,
				bsStyle: 'default',
				onClick: ()=>this.save(true, false, {}, () => this.props.newTab())
			},
			{
				divider: true
			},
			{
				title: 'Odstranit',
				icon: 'fa fa-trash-o',
				bsStyle: 'danger',
				color: '#A00',
				onClick: ()=>this.remove()
			}
		];

		return (
			<div style={{position:'relative'}}>
				<Loader visible={!!(this.props.form && this.props.form.get('loading'))} />
				<RxForm ref="form" form={this.form} id={'tab_' + this.props.tabid}>
					<Toolbar title="Otázka">
						<ButtonToolbar buttons={toolbar} />
					</Toolbar>
					<div className="row">
						<div>
							<table className="form">
								<tbody>
								<FormRow name="published" />
								<FormRow name="qsection" />
								<FormRow name="points" />
								<tr>
									<th>Skupiny I.</th>
									<td className="toggles">
										<FormField name="op_a"/> <FormField name="op_b"/> <FormField name="op_c"/> <FormField name="op_d"/> <FormField name="op_e"/> <FormField name="op_f"/> <FormField name="op_g"/> 											<FormField name="op_w1"/> <FormField name="op_w2"/> <FormField name="op_m"/> <FormField name="op_z"/>
									</td>
								</tr>
								<tr>
									<th>Skupiny II.</th>
									<td className="toggles">
										<FormField name="op_a_2"/> <FormField name="op_b_2"/> <FormField name="op_c_2"/> <FormField name="op_d_2"/> <FormField name="op_e_2"/> <FormField name="op_f_2"/> <FormField name="op_g_2"/> 											<FormField name="op_w1_2"/> <FormField name="op_w2_2"/> <FormField name="op_m_2"/> <FormField name="op_z_2"/>
									</td>
								</tr>
								<FormRow name="image" />
								<FormRow name="video" />
								<FormRow name="text" />
								<FormRow name="options" />
								<FormRow className="buttons">
									{saveCloseButton}
								</FormRow>
								</tbody>
							</table>
						</div>
					</div>
				</RxForm>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Question/Form.js